import Vue from 'vue'

import permission from './permission'

permission.install(Vue)
